import React from 'react';

export function Welcome() {
  return (
    <section className="section">
   <h1 className="about" >Welcome to a Glimpse of Hiba Qutbuddin's World!</h1>
    <div className="auText" type="text">
<p>
With deep respect for the power of knowledge and an open heart full of curiosity, I want to share my journey: 
I am Hiba Qutbuddin Habib, a future civil engineer in information and communication technology from KTH.
<br></br>
<br></br>
My first steps into the world of technology were not taken in playgrounds, but behind the gleaming screens 
and fascinating circuits. While other children were captivated by physical toys, it was the mysteries of the digital world
 that caught my interest.
<br></br>
<br></br>
My time at KTH has been an amazing journey, from being an enthusiastic amateur to becoming a knowledgeable and committed 
IT student. I have dived headfirst into the world of programming, mastered its languages from Java to Python, and learned that 
'bugs' can be more than just small annoying insects.
<br></br>
<br></br>
My latest passion is AI, a field that resembles a fascinating dance with the future, filled with potential and discoveries. 
I strive to become an expert in this field, where I can use my knowledge to create innovative solutions that make a difference.
<br></br>
<br></br>
Here I stand now, ready to share my knowledge and enthusiasm. I look forward to the opportunity to contribute to your team with
my skills, creativity, and a positive attitude. See me as a dedicated and versatile teammate, ready to add value and new perspectives.
<br></br>
<br></br>
If you are looking for someone who can combine technical competence with creative problem-solving, and who can offer a smile even in 
stressful situations, I hope we will have the opportunity to talk more. Let's together explore and shape the technology of the future - and make 
the journey there both inspiring and entertaining.
<br></br>
<br></br>
Feel free to explore more on my site to learn more about me, or contact me directly for a conversation or a meeting.
<br></br>
<br></br>
Looking forward to hearing from you and working together towards a brighter, smarter, and more inclusive technological future!
</p>

    </div>
    </section>
  )
}